/**
 * @module categoryResults
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyReportingActions } from '~/behaviors/actions/survey_reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeCategoryResults = (state, action) => {
  const categoryResults = action.payload?.entities?.categoryResults || {};

  return { ...state, ...categoryResults };
};

const mergeAttributeCategoryResults = (state, action) => {
  const categoryResults = action.payload?.entities?.categoryResults || {};

  Object.keys(categoryResults).forEach((categoryId) => {
    state[categoryId] = {
      ...state[categoryId],
      attributeResults: [...state[categoryId].attributeResults, ...categoryResults[categoryId].attributeResults],
    };
  });
};

const categoryResults = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);

  builder.addCase(surveyReportingActions.fetchReportingResults.fulfilled, mergeCategoryResults);

  builder.addCase(surveyReportingActions.fetchReportingAttributeResult.fulfilled, mergeAttributeCategoryResults);
});

export default categoryResults;
